import { Task } from '@atom/types/task';

import SectionHeading from '../shared/SectionHeading';

import TaskRow from './TaskRow';

import classes from './workOrder.module.css';

export type WorkTasksTabProps = {
  tasks: Task[];
  showDateTime?: boolean;
};

const WorkTasksTab = ({ tasks, showDateTime = false }: WorkTasksTabProps) => (
  <div className={classes.taskPanel}>
    <SectionHeading title={`${tasks.length} tasks`} />
    <div className={classes.taskList}>
      {tasks.map(task => (
        <TaskRow key={task.id} task={task} showDateTime={showDateTime} />
      ))}
    </div>
  </div>
);

export default WorkTasksTab;
